module.exports = __webpack_public_path__ + "static/media/intro-photowall-34.9f70b8ab.jpg";